import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ArticleList } from './components/article-list-app';
import { IArticleElements } from './models/article-elements'
import { IPage } from '../global/state-helpers/page';
import * as queryString from 'query-string'
import { isNullOrUndefined } from 'util';
import { createRoot } from 'react-dom/client';


const articleListingMount = document.getElementById('article-listing-app');
const newsListingMount = document.getElementById('news-listing-app');

if (articleListingMount || newsListingMount) {
    const articles = (window as any).bootstrap.Articles as IArticleElements[];
    const pageSize = (window as any).bootstrap.PageSize;

    const rawParams = queryString.parse(window.location.search, { parseNumbers: true })
    let pageModel = { page: rawParams.page ? +rawParams.page : 1, pageSize: pageSize } as IPage;

    if (articleListingMount) {
        const rootArticle = createRoot(articleListingMount);
        rootArticle.render(
            <ArticleList
                items={articles}
                pageModel={pageModel}
                newsListing={!isNullOrUndefined(newsListingMount)}
            />);
    }
    else {
        const rootNews = createRoot(newsListingMount);
        rootNews.render(
            <ArticleList
                items={articles}
                pageModel={pageModel}
                newsListing={!isNullOrUndefined(newsListingMount)}
            />);
        }
    

}